import api from "../services/api";
import { project } from "../hooks/auth";

// Utilitários para consumir SSE via fetch (EventSource não permite enviar o header Authorization).

export const API_BASE_URL = (process.env.REACT_APP_API_LOCAL_URL || "").replace(/\/$/, "");

export const resolveAuthorizationHeader = () => {
  const headerFromDefaults =
    api?.defaults?.headers?.authorization ||
    api?.defaults?.headers?.common?.authorization ||
    api?.defaults?.headers?.Authorization ||
    api?.defaults?.headers?.common?.Authorization;

  if (headerFromDefaults) return String(headerFromDefaults);

  const token = localStorage.getItem(`${project}:token`);
  if (!token) return "";
  return `Bearer ${token}`;
};

export const sleep = (ms, signal) =>
  new Promise((resolve, reject) => {
    const timeoutId = setTimeout(resolve, ms);
    const onAbort = () => {
      clearTimeout(timeoutId);
      reject(new DOMException("Aborted", "AbortError"));
    };
    if (signal) {
      if (signal.aborted) return onAbort();
      signal.addEventListener("abort", onAbort, { once: true });
    }
  });

export const parseSseBlock = (rawBlock) => {
  if (!rawBlock) return null;

  let event = "message";
  const dataLines = [];

  String(rawBlock)
    .split("\n")
    .forEach((line) => {
      const trimmed = String(line || "").replace(/\r$/, "");
      if (!trimmed) return;
      if (trimmed.startsWith(":")) return;
      if (trimmed.startsWith("event:")) {
        event = trimmed.slice("event:".length).trim() || event;
        return;
      }
      if (trimmed.startsWith("data:")) {
        dataLines.push(trimmed.slice("data:".length).replace(/^ /, ""));
      }
    });

  return { event, data: dataLines.join("\n") };
};

/**
 * Lê um stream SSE até o fim, chamando onEvent({ event, data }) para cada evento.
 * Resolve quando o servidor encerra o stream; rejeita em erro de rede/HTTP (error.status com o código HTTP).
 */
export const readSseStream = async (url, { signal, onEvent, method = "GET", body } = {}) => {
  const headers = { Accept: "text/event-stream" };
  const authorization = resolveAuthorizationHeader();
  if (authorization) headers.Authorization = authorization;
  if (body !== undefined) headers["Content-Type"] = "application/json";

  const response = await fetch(url, { method, headers, body, signal });
  if (!response.ok) {
    const error = new Error(`SSE ${url}: HTTP ${response.status}`);
    error.status = response.status;
    throw error;
  }

  const reader = response.body?.getReader?.();
  if (!reader) throw new Error(`SSE ${url}: sem stream de resposta`);

  const decoder = new TextDecoder();
  let buffer = "";
  while (!signal?.aborted) {
    const { value, done } = await reader.read();
    if (done) break;

    buffer += decoder.decode(value, { stream: true });
    buffer = buffer.replace(/\r\n/g, "\n");
    const parts = buffer.split("\n\n");
    buffer = parts.pop() || "";
    parts.forEach((block) => {
      const parsed = parseSseBlock(block);
      if (parsed) onEvent?.(parsed);
    });
  }
};
